import React from 'react'
import { Box, Tooltip, Typography } from "@mui/material"
import { IconSeeker } from "@ui-seeker/core"
import { dsColorNew } from "@palette"


export default function priceChangeComparisonColumn() {

	const iconMap = {
		"$": "money-bills",
		"%": "percent",
		"Price decrease": "arrow-down",
		"Price increase": "arrow-up",
		"Price increase/decrease": "arrow-down-arrow-up"
	}

	const colorMap = {
		"$": dsColorNew.successText,
		"%": dsColorNew.black,
		"Price decrease": dsColorNew.dangerRed,
		"Price increase": dsColorNew.successText,
		"Price increase/decrease": dsColorNew.noteAmber
	}

	return {
		name: 'comparatorValue', label: "Condition", options: {
			customBodyRowRenderLite: (value, { comparatorName, comparatorUnitName }) => <Box
				sx={{ display: "flex", justifyContent: "center", alignItems: 'center' }}>
				<Tooltip title="Amount" placement="top" arrow>
					<Typography sx={{ fontWeight: "bold" }}>{value}</Typography>
				</Tooltip>
				<IconSeeker
					tooltip={comparatorUnitName === "$" ? "Currency" : "Percentage"}
					icon={iconMap[comparatorUnitName]}
					sx={{
						mx: .7,
						fontSize: 14,
						color: colorMap[comparatorUnitName]
					}}/>
				<IconSeeker
					tooltip={comparatorName}
					icon={iconMap[comparatorName]}
					sx={{
						fontSize: 14,
						color: colorMap[comparatorName]
					}}
				/>
			</Box>
		}
	}
}